import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Loader } from '../../../common/elements'
import { PromoModalOffer, PromoModalTitle } from './elements'
import { NetworkHelpers as Network, PromotionHelpers as Promotions } from '../../../../helpers';
import * as basketActions from '../../../../actions/transactions/basket';
import * as profileActions from '../profile/actions';
import PromoModalTitleProduct from './elements/PromoModalTitleProduct';
import { currency } from './../../../../helpers/';



const data = [
    {
		network_id: 1,
		description: `
			We know that the main reason our members use NonExecutiveDirectors.com is to find their next board-level role. And market-leading companies know it too. That’s why 26,000 of them use our networks to list fantastic vacancies and market them directly to our elite professionals.
			
			This week, we’re giving you 12 month access to the full NonExecutiveDirectors.com jobs board for just ${ currency.convert( 100 ) } ex ${ currency.taxType() } - that’s two thirds off the list price.
			
			You’ll be able to browse and apply for thousands of board-level roles and exclusive opportunities you can’t find anywhere else.
		`.trim()
	},
	{
		network_id: 2,
		description: `
			We know that the main reason our members use TheConsultantHub.com is to find their next contract. And market-leading companies know it too. That’s why 26,000 of them use our networks to list fantastic vacancies and market them directly to our elite professionals.

			This week, we’re giving you 12 month access to the full TheConsultantHub.com jobs board for just ${ currency.convert( 100 ) } ex ${ currency.taxType() } - that’s two thirds off the list price.

			You’ll be able to browse and apply for thousands of consultancy roles and exclusive opportunities you can’t find anywhere else.
		`.trim()
	},
    {
		network_id: 3,
		description: `
			We know that the main reason our members use FinanceDirectorNetwork.com is to find their next board-level role. And market-leading companies know it too. That’s why 26,000 of them use our networks to list fantastic vacancies and market them directly to our elite professionals.
		
			This week, we’re giving you 12 month access to the full FinanceDirectorNetwork.com jobs board for just ${ currency.convert( 100 ) } ex ${ currency.taxType() } - that’s two thirds off the list price.

			You’ll be able to browse and apply for hundreds of finance director roles and exclusive opportunities you can’t find anywhere else.
		`.trim()
	}
];

class PromoModalPageProduct extends Component {

    constructor( props ) {
        super( props );
        this.state = {
            closeModal: false,
			addedToBasket: false,
        };
    };

    componentWillMount() {
        const { profile, getProfile, network } = this.props,
            networkId = Network.getCurrentNetwork( network ),
             personId = localStorage.getItem( "person_id" );

        if( !profile ) {
            getProfile( personId, networkId )
        } else return null;
    };

    handleAddToBasket () {

        const { network, promotion } = this.props;

        localStorage.setItem( "promo_added", 1 );

        this.props.addProductToBasket ( promotion[0].product_id );

        if( parseInt( localStorage.promo_added, 10 ) === 1 ) {
			browserHistory.push( `/${ network }/basket` );
        }
	}

    closePromoModal = () => {
        this.setState({
            closeModal: true,
        });
    };

    render () {
        const { network, profile, promotion, addProductToBasket, history, promoType } = this.props;
        const { closeModal } = this.state;
        const isOpen = true;
        const currentPromo = Promotions.getActivePromotionDetails( promoType, "package" );
        const description = data.find( e => e.network_id === promotion[0].network_id ).description;

        if ( !isOpen ) return null;
        if ( !profile ) return <Loader network={ network } />;
        if( closeModal ) return <div />;

        if( parseInt( localStorage.promo_added, 10 ) !== 1 ) {
            if( currentPromo.type === 1 ) {
                return (
                    <div className="promospage-body offer-NED">
	                    <div className="cover-promos">
		                    <button className="close" onClick={ this.closePromoModal }><i className="fa fa-times" /></button>
		                    <img className="logo-top-right" src="/images/In-Touch-Networks-logo.png" alt="In Touch Networks Logo" />
		                    <div className="container">
			                    <div className="row">
				                    <div className="col-xs-12 col-md-10 col-md-offset-1">
					                    <PromoModalTitle name={ `${ profile.first_name } ${ profile.last_name }` } description={ currentPromo.content } />
					                    test
					                    <PromoModalOffer addPromotionProductToBasket={ id => addProductToBasket( id ) } promotion={ promotion } network={ network } history={ history } />
				                    </div>
			                    </div>
		                    </div>
	                    </div>

                    </div>
                );
            } else {

				let base_price = currency.convert( promotion[0].base_price );
				let promotional_price = currency.convert( promotion[0].promotional_price );
				let currencySign = base_price.substring( 0, 1 );

                return (
                    <div className="promospage-body offer-NED">
	                    <div className="cover-promos">
		                    <img className="logo-top-right" src="/images/In-Touch-Networks-logo.png" alt="In Touch Networks Logo" />
		                    <button className="close" onClick={ this.closePromoModal }><i className="fa fa-times" /></button>
		                    <div className="container">
			                    <div className="row">
				                    <div className="col-xs-12">
					                    <div className="promo-product">
						                    <PromoModalTitleProduct name={ `${ profile.first_name } ${ profile.last_name }` } network={ promotion[0].network_id } />
						                    <main className="row">
							                    <div className="col-xs-12 col-md-12">
								                    <div className="prices">
									                    <div className="row">
										                    <div className="col-xs-6 col-md-5">
											                    <div className="price-regular">
												                    <p className="p-tag title-uppercase">Regular Price</p>
												                    <div className="price"><span className="currency">{ currencySign }</span>{ base_price.substring( 1, base_price.length ) }</div>
											                    </div>
											                    <p className="p-tag vat-info">{ `(excludes ${ currency.taxType() })` }</p>
										                    </div>
										                    <div className="hidden-xs hidden-sm col-md-2">
											                    <img src="/images/offers/icon-jobs.png" alt="" className="icon-product"/>
										                    </div>
										                    <div className="col-xs-6 col-md-5">
											                    <div className="price-promoted">
												                    <p className="p-tag title-uppercase">Limited Offer</p>
												                    <div className="price"><span className="currency">{ currencySign }</span>{ promotional_price.substring( 1, promotional_price.length ) }</div>
											                    </div>
											                    <p className="p-tag vat-info">{ `(excludes ${ currency.taxType() })` }</p>
										                    </div>
									                    </div>
								                    </div>
							                    </div>
							                    <div className="col-xs-12 col-md-12 text-center">
								                    <div className="row">
									                    <div className="col-xs-12">
										                    <h5 className="h5">Full access to hundreds of new opportunities and exclusive roles.</h5>
															<p className="p-tag hidden-xs">{description}</p>
															<ul className="buttons-center">
											                    <li>
												                    <button type='button' className="btn btn-primary" onClick={ () => this.handleAddToBasket() } >
													                    <span className="label">Claim your offer</span>
													                    <span className="icon"><i className="fa fa-angle-right animated-right" /></span>
												                    </button>
											                    </li>
										                    </ul>
									                    </div>
								                    </div>
							                    </div>
						                    </main>
					                    </div>
				                    </div>
			                    </div>
		                    </div>
	                    </div>
                    </div>
                );
            }
        } else return <div></div>;
    };
}

const mapStateToProps = state => ({
	profile: state.profile.profile,
	promotionAddedToBasket: state.transactions.promotionAddedToBasket,
	basket: state.transactions.basket,
});

const mapDispatchToProps = ( dispatch ) => ({
	getProfile: ( personId, networkId ) => dispatch( profileActions.getProfile( personId, networkId) ),
	addProductToBasket: productId => dispatch( basketActions.addProductToBasket( productId ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )( PromoModalPageProduct );



// WEBPACK FOOTER //
// src/client/components/site/features/promos/PromoModalPageProduct.js